
import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let solverProblemsSwiperWr = document.querySelectorAll('.solve-problems-swiper-wr');
solverProblemsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 940px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 12,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        breakpoints: {
          400: {
            spaceBetween: 14,
            slidesPerView: 1.1,
          },
          480: {
            spaceBetween: 16,
            slidesPerView: 1.3,
          },
          600: {
            spaceBetween: 18,
            slidesPerView: 1.6,
          },
        },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        },
    );
  }
});